import React, { useState, lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./themes/GlobalStyles";
import { lightTheme, darkTheme } from "./themes/Themes";

import HomePage from "./pages/HomePage";
import Navbar from "./components/navigation/Navbar";

const NotesPage = lazy(() => import("./pages/NotesPage.jsx"));

const App = () => {
  const [theme, setTheme] = useState("dark");
  const themeToggler = () => {
    theme === "light" ? setTheme("dark") : setTheme("light");
  };
  const [writeDiv, setWriteDiv] = useState(true);
  const [entriesDiv, setEntriesDiv] = useState(false);

  const handleWrite = () => {
    setEntriesDiv(false);
    setWriteDiv(!writeDiv);
  };

  const handleEntries = () => {
    setWriteDiv(false);
    setEntriesDiv(!entriesDiv);
  };

  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <GlobalStyles />
      <Navbar
        theme={theme}
        themeToggler={themeToggler}
        writeDiv={writeDiv}
        entriesDiv={entriesDiv}
        handleWrite={handleWrite}
        handleEntries={handleEntries}
      />
      <Routes>
        <Route path="/" element={<HomePage theme={theme} />} />

        <Route
          path="/notes"
          element={
            <Suspense fallback={<></>}>
              <NotesPage writeDiv={writeDiv} entriesDiv={entriesDiv} />
            </Suspense>
          }
        />

        <Route path="/notes/:id" element={<NotesPage />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
